if (!customElements.get('subcategory-tabs')) {
  class SubcategoryTabs extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-subcategory-track]');
      this.prevButton = this.querySelector('[data-subcategory-prev]');
      this.nextButton = this.querySelector('[data-subcategory-next]');
      if (!this.track) return;

      this.itemsPerPage = 1;
      this.onScroll = this.syncNav.bind(this);
      this.onResize = this.layout.bind(this);

      this.prevButton.addEventListener('click', () => this.scrollByPage(-1));
      this.nextButton.addEventListener('click', () => this.scrollByPage(1));
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.resizeObserver = new ResizeObserver(() => this.onResize());
      this.resizeObserver.observe(this);
      this.layout();
      this.classList.add('is-ready');
      window.addEventListener('load', this.onResize, { once: true });
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
    }

    get items() {
      return Array.from(this.track.querySelectorAll('.collection-subcategory-tabs__item'));
    }

    get gap() {
      const styles = getComputedStyle(this.track);
      return parseFloat(styles.columnGap || styles.gap) || 0;
    }

    isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    resetItemSizes() {
      this.items.forEach((item) => {
        item.style.flex = '';
        item.style.width = '';
        item.style.maxWidth = '';
      });
    }

    sizeMobileItems() {
      const items = this.items;
      if (!items.length) return;

      this.resetItemSizes();

      const available = this.track.clientWidth;
      const gap = this.gap;
      const maxNatural = Math.max(
        ...items.map((item) => item.getBoundingClientRect().width),
        0
      );

      let count = 1;
      if (maxNatural > 0 && available > 0) {
        count = Math.floor((available + gap) / (maxNatural + gap));
        count = Math.max(1, Math.min(count, items.length));
      }

      const itemWidth = Math.max(0, (available - gap * (count - 1)) / count);
      items.forEach((item) => {
        item.style.flex = `0 0 ${itemWidth}px`;
        item.style.width = `${itemWidth}px`;
        item.style.maxWidth = `${itemWidth}px`;
      });

      this.itemsPerPage = count;
    }

    layout() {
      if (this.isMobile()) {
        this.sizeMobileItems();
        this.syncNav();

        // Arrows changing visibility alters track width — size once more
        if (this.classList.contains('is-overflow')) {
          this.sizeMobileItems();
          this.syncNav();
        }
        return;
      }

      this.resetItemSizes();
      this.itemsPerPage = 1;
      this.syncNav();
    }

    pageScrollAmount() {
      if (this.isMobile()) {
        const first = this.items[0];
        if (!first) return this.track.clientWidth;
        const itemWidth = first.getBoundingClientRect().width;
        return Math.round(itemWidth * this.itemsPerPage + this.gap * Math.max(this.itemsPerPage - 1, 0));
      }

      return Math.round(this.track.clientWidth * 0.75);
    }

    scrollByPage(direction) {
      this.track.scrollBy({
        left: this.pageScrollAmount() * direction,
        behavior: 'smooth'
      });
    }

    syncNav() {
      const overflow = this.track.scrollWidth > this.track.clientWidth + 2;
      this.classList.toggle('is-overflow', overflow);
      this.prevButton.hidden = !overflow;
      this.nextButton.hidden = !overflow;

      if (!overflow) {
        this.prevButton.disabled = true;
        this.nextButton.disabled = true;
        return;
      }

      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      this.prevButton.disabled = this.track.scrollLeft <= 2;
      this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 2;
    }
  }

  customElements.define('subcategory-tabs', SubcategoryTabs);
}
